unit View.Erros_Catalogados.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UConstantes, System.StrUtils, UPersonalizacao_Tabela,
  UHelperServer, UWeb.Enum, UPersonalizacao_Tabela.Interfaces;

type
  TFViewErros_CatalogadosList = class(TForm)
    btNew: TButton;
    Erros_CatalogadosDataset: TXDataWebDataSet;
    Erros_CatalogadosDatasetid: TIntegerField;
    Erros_CatalogadosDataseterro: TStringField;
    Erros_CatalogadosDatasetexcluido: TBooleanField;
    Erros_CatalogadosDatasetinclusao: TDateTimeField;
    Erros_CatalogadosDatasetalteracao: TDateTimeField;
    Erros_CatalogadosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
    procedure Erros_CatalogadosDataseterroGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewErros_CatalogadosList: TFViewErros_CatalogadosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewErros_CatalogadosList }

procedure TFViewErros_CatalogadosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewErros_CatalogadosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewErros_CatalogadosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewErros_CatalogadosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewErros_CatalogadosList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewErros_CatalogadosList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewErros_CatalogadosList.Erros_CatalogadosDataseterroGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString);
end;

procedure TFViewErros_CatalogadosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewErros_CatalogadosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewErros_CatalogadosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Erros_CatalogadosDataset.Connection.Model.DefaultSchema.FindEntityType(Erros_CatalogadosDataset.EntitySetName),
      Erros_CatalogadosDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_erro_catalogado');
  end;
end;

procedure TFViewErros_CatalogadosList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['erro']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewErros_CatalogadosList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewErros_CatalogadosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('erros_catalogados', 'active');
  TUtils.SetValorDicionarioClasses('sincronizacao_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_sincronizacao', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Erros_CatalogadosDataset,
    lcPaginator, lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewErros_CatalogadosList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Erros_CatalogadosDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewErros_CatalogadosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.erros_catalogados.list.pagination.info');
  btNew := TButton.Create('view.erros_catalogados.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.erros_catalogados.list.table');
  cbPageSize := TComboBox.Create('view.erros_catalogados.list.cbPageSize');
  edSearch := TEdit.Create('view.erros_catalogados.list.search');
  lcPaginator := TListControl.Create('view.erros_catalogados.list.pagination');
  Erros_CatalogadosDataset := TXDataWebDataSet.Create(Self);
  Erros_CatalogadosDatasetid := TIntegerField.Create(Self);
  Erros_CatalogadosDataseterro := TStringField.Create(Self);
  Erros_CatalogadosDatasetexcluido := TBooleanField.Create(Self);
  Erros_CatalogadosDatasetinclusao := TDateTimeField.Create(Self);
  Erros_CatalogadosDatasetalteracao := TDateTimeField.Create(Self);
  Erros_CatalogadosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Erros_CatalogadosDataset.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetid.BeforeLoadDFMValues;
  Erros_CatalogadosDataseterro.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetexcluido.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetinclusao.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetalteracao.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewErros_CatalogadosList';
    Width := 552;
    Height := 413;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'Novo';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'erro';
      Title := 'erro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Erros_CatalogadosDataset.SetParentComponent(Self);
    Erros_CatalogadosDataset.Name := 'Erros_CatalogadosDataset';
    Erros_CatalogadosDataset.EntitySetName := 'Erros_Catalogados';
    Erros_CatalogadosDataset.Connection := DMConnection.ApiConnection;
    Erros_CatalogadosDataset.Left := 72;
    Erros_CatalogadosDataset.Top := 144;
    Erros_CatalogadosDatasetid.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetid.Name := 'Erros_CatalogadosDatasetid';
    Erros_CatalogadosDatasetid.FieldName := 'id';
    Erros_CatalogadosDatasetid.Required := True;
    Erros_CatalogadosDataseterro.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDataseterro.Name := 'Erros_CatalogadosDataseterro';
    Erros_CatalogadosDataseterro.FieldName := 'erro';
    Erros_CatalogadosDataseterro.Required := True;
    SetEvent(Erros_CatalogadosDataseterro, Self, 'OnGetText', 'Erros_CatalogadosDataseterroGetText');
    Erros_CatalogadosDataseterro.Size := 255;
    Erros_CatalogadosDatasetexcluido.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetexcluido.Name := 'Erros_CatalogadosDatasetexcluido';
    Erros_CatalogadosDatasetexcluido.FieldName := 'excluido';
    Erros_CatalogadosDatasetinclusao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetinclusao.Name := 'Erros_CatalogadosDatasetinclusao';
    Erros_CatalogadosDatasetinclusao.FieldName := 'inclusao';
    Erros_CatalogadosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Erros_CatalogadosDatasetalteracao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetalteracao.Name := 'Erros_CatalogadosDatasetalteracao';
    Erros_CatalogadosDatasetalteracao.FieldName := 'alteracao';
    Erros_CatalogadosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Erros_CatalogadosDatasetexclusao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetexclusao.Name := 'Erros_CatalogadosDatasetexclusao';
    Erros_CatalogadosDatasetexclusao.FieldName := 'exclusao';
    Erros_CatalogadosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Erros_CatalogadosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 328;
    tmrConsulta.Top := 136;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Erros_CatalogadosDataset.AfterLoadDFMValues;
    Erros_CatalogadosDatasetid.AfterLoadDFMValues;
    Erros_CatalogadosDataseterro.AfterLoadDFMValues;
    Erros_CatalogadosDatasetexcluido.AfterLoadDFMValues;
    Erros_CatalogadosDatasetinclusao.AfterLoadDFMValues;
    Erros_CatalogadosDatasetalteracao.AfterLoadDFMValues;
    Erros_CatalogadosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
